module.exports = __webpack_public_path__ + "media/event-access/webinar@2x-35f1df88.png";